import { useCallback, useState } from 'react';
import { useClient } from '../../../../context/client';

export function useExportSelected(selectedItems, vendor) {
	const [isLoading, setIsLoading] = useState(false);
	const client = useClient();

	const handleExport = useCallback(async () => {
		setIsLoading(true);

		const orderIds = selectedItems.map((value) => value.bc_order_id);

		if (selectedItems.length) {
			try {
				await client.exportOrders('pdf', orderIds, { vendor });
			} finally {
				setIsLoading(false);
			}
			return;
		}

		setIsLoading(false);
	}, [client, selectedItems, vendor]);

	return [handleExport, isLoading];
}
